import * as LucideIcons from "lucide-react";
import type { LucideIcon } from "lucide-react";

const SKIP = new Set(["Icon", "LucideIcon", "createLucideIcon"]);

export const DEFAULT_SERVICE_ICON = "Briefcase";

export const DEFAULT_SERVICE_ICONS_BY_SLUG: Record<string, string> = {
  "audit-assurance": "FileSearch",
  "tax-services": "Calculator",
  advisory: "Users",
  "esg-advisory": "Handshake",
  "business-outsourcing-services": "Briefcase",
  "financial-planning-analysis": "TrendingUp",
  "other-services": "Layers",
};

let cachedIconNames: string[] | null = null;

export function listLucideIconNames(): string[] {
  if (cachedIconNames) return cachedIconNames;
  cachedIconNames = Object.keys(LucideIcons)
    .filter((name) => {
      if (SKIP.has(name) || !/^[A-Z]/.test(name)) return false;
      const candidate = (LucideIcons as Record<string, unknown>)[name];
      return typeof candidate === "function";
    })
    .sort();
  return cachedIconNames;
}

export function getLucideIcon(name: string | null | undefined): LucideIcon | null {
  if (!name) return null;
  const icon = (LucideIcons as Record<string, LucideIcon | undefined>)[name];
  return icon ?? null;
}

export function resolveServiceIconName(iconName: string | null | undefined, slug: string): string {
  if (iconName && getLucideIcon(iconName)) return iconName;
  return DEFAULT_SERVICE_ICONS_BY_SLUG[slug] ?? DEFAULT_SERVICE_ICON;
}

export function LucideIconByName({
  name,
  className,
  strokeWidth,
}: {
  name: string | null | undefined;
  className?: string;
  strokeWidth?: number;
}) {
  const Icon = getLucideIcon(name) ?? getLucideIcon(DEFAULT_SERVICE_ICON)!;
  return <Icon className={className} strokeWidth={strokeWidth} />;
}
